import { useEffect, useMemo } from 'react';
import { usePrevious } from '@fortress-technology-solutions/fortress-component-library/hooks';
import useReactHookFormProps from '../../../../../hooks/useReactHookFormProps';
import { formatDateDB } from '@fortress-technology-solutions/fortress-component-library/utils';
import moment from 'moment/moment';
import { FIELDS } from './constants';
import isEqual from 'lodash/isEqual';

const getDefaultValues = (values) => {
  return {
    HTFAffordabilityPeriodStartDate: values?.HTFAffordabilityPeriodStartDate
      ? moment(values.HTFAffordabilityPeriodStartDate)
      : '',
    HTFUnitType: values?.HTFUnitType || '',
  };
};

const normalizeEmptyStringToNull = (value) => (value === '' ? null : value);

export const useHTF = ({ editMode, values, onChange }) => {
  const prevValues = usePrevious(values);
  const hasValuesChanged = !isEqual(prevValues, values);
  const ReactHookFormProps = useReactHookFormProps({
    defaultValues: getDefaultValues(values),
  });

  const memoizedFields = useMemo(() => {
    const fieldsCopy = [...FIELDS];

    return fieldsCopy.map((field) => ({
      ...field,
      readOnly: !editMode,
      placeholder: editMode ? undefined : field.placeholder,
    }));
  }, [editMode]);

  const { reset, watch } = ReactHookFormProps;

  useEffect(() => {
    if (!hasValuesChanged) return;
    reset(getDefaultValues(values));
  }, [hasValuesChanged, reset, values]);

  const HTFAffordabilityPeriodStartDate = watch(
    'HTFAffordabilityPeriodStartDate',
  );
  useEffect(() => {
    const formattedHTFAffordabilityPeriodStartDate =
      formatDateDB(HTFAffordabilityPeriodStartDate) || null;

    onChange({
      target: {
        name: 'setup.HTFAffordabilityPeriodStartDate',
        value: formattedHTFAffordabilityPeriodStartDate,
      },
    });
  }, [HTFAffordabilityPeriodStartDate, onChange]);

  const HTFUnitType = watch('HTFUnitType');
  useEffect(() => {
    const normalizedHTFUnitType = normalizeEmptyStringToNull(HTFUnitType);

    onChange({
      target: {
        name: 'setup.HTFUnitType',
        value: normalizedHTFUnitType,
      },
    });
  }, [HTFUnitType, onChange]);

  return {
    ReactHookFormProps,
    memoizedFields,
  };
};
